// extracted by mini-css-extract-plugin
module.exports =  {"root":"rATTBIs1TxCrmHslJLgb","speechBubble":"BLtKlVw7kP7uDdNvruBD","mascotImage":"bf6zBiC98koiMFmaR4sT"};